<ng-template #loader>
  <div class="mat-elevation-z1 shimmer-container">
    <div *ngFor="let _ of [].constructor(16)" class="stencil-shimmer shimmer"></div>
  </div>
</ng-template>
<div>
  <ng-container *ngIf="meetings$ | async as meetings; else loader">
    <div class="page-container">
      <div class="meeting-list-filters">
        <meeting-scheduler-meeting-filter
          class="calendar-meeting-filter"
          [meetingTypes]="allMeetingTypes$ | async"
          [selectedFilter]="selectedEventTypeFilter"
          (meetingTypeIdsSelected)="filterByMeetingTypeIds($event)"
        ></meeting-scheduler-meeting-filter>
        @if (selectedTab === 'past') {
          <forms-time-range-selector
            class="calendar-time-filter"
            [timeRangeOption]="timeRangeKeySelected"
            [timeRangeOptions]="timeRangeOptions"
            [max]="now"
            [useGalaxyFields]="true"
            (dateRangeChange)="setDateRange($event)"
            (timeRangeChange)="setTimeRangeKey($event)"
          ></forms-time-range-selector>
        }
        <div class="meeting-list-toggle-wrapper">
          <mat-button-toggle-group
            class="calendar-tab-toggle-group"
            (change)="changedMeetingListTab($event.value)"
            [value]="'upcoming'"
          >
            <mat-button-toggle class="calendar-tab-toggle" value="upcoming"
              >{{ 'MEETING_SCHEDULER.MEETING_LIST.UPCOMING' | translate }}
            </mat-button-toggle>
            <mat-button-toggle class="calendar-tab-toggle" value="past">{{
              'MEETING_SCHEDULER.MEETING_LIST.PAST' | translate
            }}</mat-button-toggle>
          </mat-button-toggle-group>
        </div>
      </div>
      <div class="margin-top-component"></div>
      <ng-container *ngIf="hideLoader$ | async; else loadingPage">
        <ng-container *ngIf="(meetings$ | async)?.length; else nomeetings">
          <div class="pad-style scrollable-container" (scroll)="onScroll($event)">
            <mat-accordion>
              <ng-container *ngFor="let meeting of dataSource$ | async; let i = index; trackBy: trackByMeetingId">
                <div *ngIf="!isSameDate(meeting?.date.start | date: 'EEEE, MMM d, y', i)" class="date">
                  {{ meeting?.date.start | date: ' MMM d, y' }}
                </div>

                <mat-expansion-panel class="expansion-panel" data-action="expanded-meeting-card">
                  <mat-expansion-panel-header>
                    <mat-panel-title class="expansion-panel-title">
                      <div class="flex-class">
                        <div class="margin-right-10">
                          <mat-icon
                            class="expansion-panel-header-icon"
                            *ngIf="meeting?.location === '' && meeting?.joinMeeting !== ''"
                            >event
                          </mat-icon>
                          <mat-icon
                            class="expansion-panel-header-icon"
                            *ngIf="meeting?.location !== '' && meeting?.joinMeeting === ''"
                          >
                            location_on
                          </mat-icon>
                          <mat-icon
                            class="expansion-panel-header-icon"
                            *ngIf="meeting?.location !== '' && meeting?.joinMeeting !== ''"
                          >
                            business
                          </mat-icon>
                        </div>
                        <div>
                          <div class="title-text">
                            {{ meeting.date.start | date: 'shortTime' }} - {{ meeting?.date.end | date: 'shortTime' }}
                          </div>
                          <span class="subtitle-text">
                            {{ meeting.topic || '—' }}
                          </span>
                        </div>
                      </div>
                      <div (click)="stopPropagation($event)">
                        @if (selectedTab === 'upcoming') {
                          <div class="expansion-panel-header-button-group">
                            <button
                              mat-flat-button
                              color="primary"
                              class="expansion-panel-header-button-width margin-right-10"
                              *ngIf="meeting?.joinMeeting"
                              (click)="openMeetingLink(meeting?.joinMeeting)"
                              data-action="clicked-join-meeting-button"
                            >
                              <mat-icon class="join-button-icon">video_call</mat-icon>
                              {{ 'MEETING_SCHEDULER.CALENDER_VIEW.MEETING_LIST.JOIN' | translate }}
                            </button>
                            <button
                              mat-stroked-button
                              class="expansion-panel-header-button-width"
                              [matMenuTriggerFor]="modifyMeeting"
                              data-action="clicked-edit-meeting-button"
                            >
                              <mat-icon class="edit-button-icon">edit</mat-icon>
                              {{ 'MEETING_SCHEDULER.CALENDER_VIEW.MEETING_LIST.EDIT' | translate }}
                            </button>
                            <mat-menu #modifyMeeting="matMenu" class="modify-meeting-menu">
                              <button mat-menu-item>
                                <meeting-scheduler-reschedule-meeting-button
                                  [meeting]="meeting"
                                  [isMatItem]="true"
                                ></meeting-scheduler-reschedule-meeting-button>
                              </button>
                              <button mat-menu-item>
                                <meeting-scheduler-cancel-meeting-button
                                  [meeting]="meeting"
                                  [isMatItem]="true"
                                  [displayText]="'MEETING_SCHEDULER.CALENDER_VIEW.MEETING_LIST.CANCEL' | translate"
                                ></meeting-scheduler-cancel-meeting-button>
                              </button>
                            </mat-menu>
                          </div>
                        }
                      </div>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <ng-container
                    *ngIf="!meeting.isSessionEventType; else sessionEventTypeMeetingDetails"
                    [ngTemplateOutlet]="standardMeetingLayout"
                    [ngTemplateOutletContext]="{ $implicit: meeting }"
                  >
                  </ng-container>
                  <ng-template #sessionEventTypeMeetingDetails>
                    <ng-container
                      [ngTemplateOutlet]="sessionEventMeetingLayout"
                      [ngTemplateOutletContext]="{ $implicit: meeting }"
                    ></ng-container>
                  </ng-template>
                </mat-expansion-panel>
              </ng-container>
            </mat-accordion>

            <div *ngIf="isLoadingMore" class="inline-loader-container">
              <glxy-loading-spinner size="medium"></glxy-loading-spinner>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </ng-container>

  <ng-template #nomeetings>
    <glxy-empty-state>
      <glxy-empty-state-hero>
        <img
          src="https://vstatic-prod.apigateway.co/partner-center-client/assets/booking_empty_state.png"
          alt="No meetings scheduled"
        />
      </glxy-empty-state-hero>
      <glxy-empty-state-title>
        {{
          (selectedTab === 'past'
            ? 'MEETING_SCHEDULER.MEETING_LIST.EMPTY_STATE.PAST_TITLE'
            : 'MEETING_SCHEDULER.MEETING_LIST.EMPTY_STATE.UPCOMING_TITLE_V2'
          ) | translate
        }}
      </glxy-empty-state-title>
      <p>
        {{
          (selectedTab === 'past'
            ? 'MEETING_SCHEDULER.MEETING_LIST.EMPTY_STATE.PAST_DESCRIPTION'
            : 'MEETING_SCHEDULER.MEETING_LIST.FILTER_NO_RESULTS_V2'
          ) | translate
        }}
      </p>
    </glxy-empty-state>
  </ng-template>
  <ng-template #loadingPage>
    <glxy-loading-spinner size="large" [fullWidth]="true" [fullHeight]="true"></glxy-loading-spinner>
  </ng-template>

  <!-- Standard Meeting Layout Template -->
  <ng-template #standardMeetingLayout let-meeting>
    <div class="meeting-details-grid">
      <div class="grid-item">
        <div class="meeting-subtitle">{{ 'MEETING_SCHEDULER.MEETING_LIST.EMAIL_LABEL' | translate }}</div>
        <div class="comment">{{ meeting?.attendeeEmails || '—' }}</div>
      </div>
      <div class="grid-item">
        <div class="meeting-subtitle">
          {{ 'MEETING_SCHEDULER.MEETING_LIST.CONTACT_LABEL' | translate }}
        </div>
        <div class="comment">{{ meeting?.contact?.phoneNumber || '—' }}</div>
      </div>
      <div class="grid-item">
        <div class="meeting-subtitle">
          {{ 'MEETING_SCHEDULER.MEETING_LIST.LOCATION_LABEL' | translate }}
        </div>
        <div class="comment">
          <div>{{ meeting?.location || '—' }}</div>
        </div>
      </div>
      <div class="grid-item">
        <div class="meeting-subtitle">
          {{ 'MEETING_SCHEDULER.MEETING_LIST.MEETING_LINK' | translate }}
        </div>
        <div class="comment">
          <ng-container *ngIf="meeting?.joinMeeting; else noLink">
            <a class="meeting-link" [matTooltip]="meeting?.joinMeeting" (click)="openMeetingLink(meeting?.joinMeeting)">
              {{
                meeting?.joinMeeting?.length > 40
                  ? meeting?.joinMeeting?.substring(0, 40) + '...'
                  : meeting?.joinMeeting
              }}
            </a>
          </ng-container>
          <ng-template #noLink> —</ng-template>
        </div>
      </div>
      <div class="grid-item" *ngIf="meeting?.hostNames.length > 0">
        <div class="meeting-subtitle">
          {{ 'MEETING_SCHEDULER.MEETING_LIST.HOSTS_LABEL' | translate }}
        </div>
        <div class="comment">{{ meeting?.hostNames.join(', ') || '—' }}.</div>
      </div>
      <div class="grid-item">
        <div class="meeting-subtitle">
          {{ 'MEETING_SCHEDULER.MEETING_LIST.COMMENTS_LABEL' | translate }}
        </div>
        <div class="comment">{{ meeting?.comments || '—' }}</div>
      </div>
      <div *ngIf="meeting?.formAnswers.length > 0" class="grid-item form-answers-section">
        <div class="meeting-subtitle">
          {{ 'MEETING_SCHEDULER.MEETING_LIST.CUSTOM_QUESTION_LABEL' | translate }}
        </div>
        <div class="form-answers-grid">
          <div *ngFor="let answer of meeting?.formAnswers" class="form-answer-item">
            <div class="meeting-subtitle">{{ answer.label }}</div>
            <div class="comment">{{ answer.answer.join(', ') }}</div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <!-- Session Event Layout Template -->
  <ng-template #sessionEventMeetingLayout let-meeting>
    <div class="meeting-details-grid">
      <div class="grid-item">
        <div class="meeting-subtitle">
          {{ 'MEETING_SCHEDULER.MEETING_LIST.HOSTS_LABEL' | translate }}
        </div>
        <div class="comment">{{ meeting?.hostNames?.join(', ') || '—' }}</div>
      </div>

      <div class="grid-item">
        <div class="meeting-subtitle">
          {{ 'MEETING_SCHEDULER.MEETING_LIST.BOOKING_PAGE_LINK' | translate }}
        </div>
        <div class="comment">
          <ng-container *ngIf="meeting?.sessionRegistrationUrl; else noLink">
            <a
              class="meeting-link"
              [href]="meeting?.sessionRegistrationUrl"
              [matTooltip]="meeting?.sessionRegistrationUrl"
              target="_blank"
              (click)="stopPropagation($event)"
            >
              {{ meeting?.sessionRegistrationUrl }}
            </a>
          </ng-container>
          <ng-template #noLink> —</ng-template>
        </div>
      </div>
      <div class="grid-item">
        <div class="meeting-subtitle">
          {{ 'MEETING_SCHEDULER.MEETING_LIST.LOCATION_LABEL' | translate }}
        </div>
        <div class="comment">{{ meeting?.location || '—' }}</div>
      </div>
      <div class="grid-item">
        <div class="meeting-subtitle">
          {{ 'MEETING_SCHEDULER.MEETING_LIST.MEETING_LINK' | translate }}
        </div>
        <div class="comment">
          <ng-container *ngIf="meeting?.joinMeeting; else noLink">
            <a class="meeting-link" [matTooltip]="meeting?.joinMeeting" (click)="openMeetingLink(meeting?.joinMeeting)">
              {{ meeting?.joinMeeting }}
            </a>
          </ng-container>
          <ng-template #noLink> —</ng-template>
        </div>
      </div>
      <div class="grid-item">
        <div class="meeting-subtitle">
          {{ 'MEETING_SCHEDULER.MEETING_LIST.REGISTRATION_CUTOFF_TIME' | translate }}
        </div>
        <div class="comment">{{ meeting?.registrationCutoff || '—' }}</div>
      </div>
      <div class="grid-item">
        <div class="meeting-subtitle">
          {{ 'MEETING_SCHEDULER.MEETING_LIST.TOTAL_REGISTRATIONS' | translate }}
        </div>
        <div class="comment">
          <a class="meeting-link" (click)="openAttendeeListDialog(meeting)">
            {{ 'MEETING_SCHEDULER.MEETING_LIST.MANAGE' | translate }}
          </a>
        </div>
        <div class="comment">{{ meeting?.registeredAttendeeCount || 0 }} / {{ meeting?.maxAttendeeCount || 0 }}</div>
      </div>
      <div class="grid-item">
        <div class="meeting-subtitle">
          {{ 'MEETING_SCHEDULER.MEETING_LIST.ADD_TO_MY_WEBSITE' | translate }}
        </div>
        <div class="comment">
          <button
            mat-stroked-button
            [cdkCopyToClipboard]="generateEmbedCode(meeting)"
            (click)="handleCopyEmbedCodeClicked()"
          >
            {{ 'MEETING_SCHEDULER.MEETING_LIST.COPY_CODE' | translate }}
          </button>
        </div>
      </div>
    </div>
  </ng-template>
</div>
